import styled from 'styled-components';
import { Section } from 'Container';
import { asRem, breakpoints } from '@missionme/mime_elements';

export default styled(Section)`
  padding-top: ${asRem(12)};
  & > .container {
    width: calc(100% - 2rem);

    @media (min-width: ${breakpoints.sm}) {
      width: ${asRem(600)};
    }
  }

  .mime-elements-paragraph {
    margin-bottom: ${asRem(24)};
  }

  .center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
